import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "description",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemName').toString(),
        },
        name_i18n: {
            type: DataType.Object,
            title: i18n.t('dataitem.MultiLanguage').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        displayFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayConditions').toString(),
        },
    },
};
